export interface Module {
  title: string
  body: string
  /** Spine color of the matching book in the box-set mockup */
  color: string
}

export const modules: Module[] = [
  {
    title: 'MODULE 1 — AIRCRAFT SYSTEMS VISUAL ATLAS™',
    body: 'Understand aircraft structures, piston engines, propellers, fuel systems, electrical equipment, flight controls, landing gear, and essential aircraft components through annotated diagrams, labeled illustrations, system breakdowns, and technical visual references.',
    color: '#0B1F3A',
  },
  {
    title: 'MODULE 2 — FLIGHT INSTRUMENTS & COCKPIT VISUAL ATLAS™',
    body: 'Learn to recognize and interpret primary flight instruments, engine indicators, navigation displays, traditional cockpit layouts, and modern glass cockpit information using detailed instrument illustrations, cockpit diagrams, and visual interpretation examples.',
    color: '#1F6FB2',
  },
  {
    title: 'MODULE 3 — AERODYNAMICS & FLIGHT MANEUVERS VISUAL ATLAS™',
    body: 'Visualize lift, drag, thrust, weight, angle of attack, aircraft stability, stalls, load factors, coordinated flight, climbs, descents, and turns through aerodynamic diagrams, flight attitude comparisons, and illustrated maneuver concepts.',
    color: '#2E7D32',
  },
  {
    title: 'MODULE 4 — AVIATION NAVIGATION & AIRSPACE VISUAL ATLAS™',
    body: 'Explore VFR navigation, aeronautical chart symbols, airspace classifications, navigation checkpoints, magnetic headings, wind correction, pilotage, dead reckoning, and GPS navigation concepts using annotated charts, airspace illustrations, and route-planning examples.',
    color: '#E0A526',
  },
  {
    title: 'MODULE 5 — AVIATION WEATHER & FLIGHT PLANNING VISUAL ATLAS™',
    body: 'Understand aviation weather, METAR and TAF interpretation, cloud formations, wind, turbulence, visibility, density altitude, aircraft performance, fuel planning, and weight and balance through weather illustrations, planning examples, and visual reference charts.',
    color: '#C62828',
  },
  {
    title: 'MODULE 6 — FLIGHT PROCEDURES & EMERGENCY SCENARIOS VISUAL ATLAS™',
    body: 'Explore preflight preparation, cockpit checklists, airport operations, radio communication concepts, traffic patterns, takeoff and landing sequences, abnormal situations, and aeronautical decision-making through structured visual workflows and educational flight scenarios.',
    color: '#5E35B1',
  },
]
